module.exports = __webpack_public_path__ + "img/HIW-COVER.65404c06.png";